import { PropsWithChildren } from 'react';

import useUnauthRedirects from 'hooks/auth/use-unauth-redirects';
import { useAuthContext } from 'state/auth';

const UnauthRequired = ({ children }: PropsWithChildren) => {
  const { isAuthenticated } = useAuthContext();

  const redirect = useUnauthRedirects();
  if (redirect) {
    return redirect;
  }

  return !isAuthenticated ? <>{children}</> : null;
};

export default UnauthRequired;
